var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKuwait(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 496 496",
    style: {
      enableBackground: "new 0 0 496 496"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DB2727"
    },
    d: "M0,304v65.6C0,396.8,21.6,416,48,416h400c26.4,0,48-19.2,48-46.4V304H0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#359846"
    },
    d: "M448,80H48C21.6,80,0,99.2,0,126.4V192h496v-65.6C496,99.2,474.4,80,448,80z"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 192,
    style: {
      fill: "#FFFFFF"
    },
    width: 496,
    height: 112
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C61A1A"
    },
    d: "M446.4,416c26.4,0,49.6-19.2,49.6-46.4V304H315.2L446.4,416z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#218930"
    },
    d: "M448,80H48l132.8,112H496v-65.6C496,99.2,474.4,80,448,80z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CFE5E2"
    },
    points: "316,304 496,304 496,192 180,192 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#167221"
    },
    d: "M448,80H48l370.4,112H496v-65.6C496,99.2,474.4,80,448,80z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BAD3CF"
    },
    points: "496,214.4 496,192 414.4,192 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B20B0B"
    },
    d: "M496,368.8c0,29.6-21.6,47.2-48,47.2H48c-26.4,0-48-20.8-48-48"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#383737"
    },
    d: "M0,126.4v64v0.8v114.4v0.8v64c0,7.2,1.6,14.4,4.8,20.8l83.2-84V188.8L4.8,105.6 C1.6,112,0,119.2,0,126.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#151515"
    },
    d: "M0,192v-0.8v114.4v0.8v64c0,7.2,1.6,14.4,4.8,20.8l83.2-84V192"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKuwait);
export default __webpack_public_path__ + "static/media/kuwait.7b13722255696e669cf7e2b855094cf8.svg";
export { ForwardRef as ReactComponent };